import React, { useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';


export const Main = (props) => {

    const contClass = props.flexDirection ? "d-flex gap-2 gap-md-3 flex-fill " + props.flexDirection : "d-flex gap-2 gap-md-3 flex-fill flex-column flex-md-row"; 
   
    return (
        <div className="tool-main-content" >
            <div className={contClass}>
                {props.children}
            </div>
        </div>
    )
}
